import React from 'react'

import PropTypes from 'prop-types'

import './rea-ttulo.css'

const ReaTtulo = (props) => {
  return (
    <div className={`rea-ttulo-container ${props.rootClassName} `}>
      <span className="rea-ttulo-text">{props.text}</span>
    </div>
  )
}

ReaTtulo.defaultProps = {
  rootClassName: '',
  text: 'Atividades',
}

ReaTtulo.propTypes = {
  rootClassName: PropTypes.string,
  text: PropTypes.string,
}

export default ReaTtulo
